import { Icon, Loading } from '@startlibs/components';
import { css } from 'styled-components';
import { formatDate, getColor, media } from '@startlibs/utils';
import { transparentize } from 'polished';
import React from 'react'
import styled from 'styled-components/macro';
import { dicomDateToDate } from '../../utils';
import { dateMessages } from '../../uploader/lib/utils/dateMessages';

export const RecordItemStyled = styled.div`
  background: #f0f6f8;
  border-radius: 6px;
  position: relative;
  padding: 1rem;
  & ~ & {
    margin-top: 0.75rem;
  }
  ${props => !props.isOnPanel && css`
    padding: 1.5rem;
    margin-top: 1rem;
    ${media.desktop `
      border: 1px solid #cddee3;
      padding: 0.75rem 1.5rem 0.75rem 7rem;
      min-height: 78px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    `}
  `}
`

const PatientName = styled.div `
  font-weight: bold;
  font-size: 13px;
  padding-right: 2.5rem;
`
const RecordDescription = styled.div `
  margin-top: 3px;
  font-size: 13px;
  ${props => !props.isOnPanel && `
    font-size: 12px;
    margin-top: 1px;
  `}
  ${props => props.small && `
    color: rgba(0,0,0,0.5);
    font-size: 11px;
  `}
`


export const RemoveRecordIcon = styled(Icon).attrs({icon:'x'})`
  position: absolute;
  right: 0.5rem;
  top: 1.5rem;
  height: 2.25rem;
  width: 2.25rem;
  text-align: center;
  line-height: 2.25rem;
  border-radius: 50%;
  // background: #d9e8ed;
  color: #B4B4B4;
  font-size: 20px;
  cursor: pointer;
  :hover {
    background: ${props => transparentize(0.9, getColor("alert")(props))};
    color: ${getColor('alert')};
  }
  :active {
    // background: ${props => transparentize(0.85, getColor("alert")(props))};
    color: ${getColor('alert')};
  }
`

export const SelectingItem = ({study, setSelectedStudiesToRoute }) => {

  return <RecordItemStyled isOnPanel>
      
      <PatientName>Patient: {study.patient?.patientName?.trim()}</PatientName>
      <RemoveRecordIcon onClick={() => {
        setSelectedStudiesToRoute(selectedStudiesToRoute => selectedStudiesToRoute.filter(item => item?.study?.iuid !== study?.study?.iuid))
      }}/>
      <RecordDescription isOnPanel>{study.study.modalities}{study.study.modalities && " - "}{study.study.studyDescription} {study.study.studyDate && <span className='nowrap'>({formatDate(dicomDateToDate(study.study.studyDate), 'yyyy-MM-dd', dateMessages, true)})</span>}</RecordDescription>
      
  </RecordItemStyled>
}